module.exports = function() {
  return new Worker(__webpack_public_path__ + "web-worker.7563a453e5f847b5c30c.js");
};